import BucketApiRequest from "./BucketApiRequest";
import { GETTING_STARTED_GET_BRANCHES } from "../ApiUrls";

export default class GettingStartedGetBranchRequest extends BucketApiRequest {
  getUrl = () => {
    return GETTING_STARTED_GET_BRANCHES;
  };
}
